import { jsx as e } from "react/jsx-runtime";

import { memo as o, createElement as t, useMemo as r } from "react";

import { INPUT_VARIANT_CLASSES as i } from "../../constants/index.js";

import a from "../../hooks/useId/index.js";

import s from "../../utils/classNames/index.js";

import n from "./Option/index.js";

import l from "./utils/getOptionValueDefault/index.js";

import u from "./utils/getOptionLabelDefault/index.js";

import d from "./utils/isOptionDisabledDefault/index.js";

import p from "./utils/isOptionReadonlyDefault/index.js";

const c = [];

let m = !1, f = !1;

const b = () => {}, g = (e, o) => {
    throw console.log("errValue: ", e), new Error(`RadioGroup: ${o}`);
}, y = (e, o) => {
    switch (typeof e) {
      case "undefined":
        return e;

      case "string":
      case "number":
        if (!o) return [ e ];
        g(e, "value must be an array when multiple={true}");

      case "object":
        if (null === e) return;
        if (o && Array.isArray(e)) return e;
        g(e, "value must be a string or number when multiple={false}");

      default:
        g(e, "got wrong value type. Must be string or number or array of them");
    }
}, x = document.createElement("canvas").getContext("2d");

x && (x.font = window.getComputedStyle(document.body).font);

const h = e => "number" == typeof e ? `${e}px` : e, v = o((({name: o, value: v, defaultValue: O, disabled: w, readOnly: j, variant: D, className: N, id: k, onChange: E, required: C, skipDefaultStyling: V, renderOption: $, options: L, multiple: R = !1, columns: I = 0, columnWidth: A = 0, getOptionValue: G = l, getOptionLabel: P = u, isOptionDisabled: W = d, isOptionReadOnly: q = p, getInputProps: M = b, getLabelProps: S = b, ...T}) => {
    const Y = a(k), _ = D && i[D];
    "production" !== process.env.NODE_ENV && (void 0 === T["aria-invalid"] || m || (console.warn("You should not pass aria-invalid prop to <RadioGroup /> directly. It is computed from variant === error."), 
    m = !0), void 0 !== T["aria-labelledby"] || f || (console.log({
        name: o,
        value: v
    }), console.warn("You should pass aria-labelledby prop to <RadioGroup />. It is better for accessibility"), 
    f = !0));
    const z = R ? "checkbox" : "radio", B = R ? "checkbox" : "radio", F = y(v, R), H = y(O, R), J = ((e, o) => r((() => {
        let t = 0;
        if (x) for (const r of e) {
            const i = o(r);
            if ("string" == typeof i) {
                const e = Math.ceil(x.measureText(i).width);
                e > t && (t = e);
            } else g({
                label: i,
                options: e
            }, "useLongestLabelWidth feature works only for string labels. Either use strings labels or specify columns or columnWidth explicitly.");
        } else "production" !== process.env.NODE_ENV && console.warn("canvasApi is not supported");
        return t;
    }), [ e, o ]))(I || A || !L ? c : L, P);
    return L && e(R ? "ul" : "div", {
        ...T,
        role: R ? "group" : "radiogroup",
        "aria-required": R ? void 0 : C ? "true" : "false",
        id: Y,
        style: {
            /*
                      22px - width of radio/checkbox box
                      8px - offset between box and label (currently gap-xs, defined in spacings)
  
                      TODO: remove hardcoded stuff
                  */
            gridTemplateColumns: I ? `repeat(${I},auto)` : `repeat(auto-fill, minmax(${h(A || 30 + J)}, 1fr))`
        },
        className: s(
        /* TODO: replace hardcoded 4px */
        "not-prose grid", V ? "" : s("gap-y-xs gap-x-s items-center rounded-[4px]", D ? "p-xxs" : ""), _, N),
        children: L.map((e => {
            const r = G(e), i = M(e);
            return t(n, {
                ...i,
                key: r,
                render: $,
                id: `${Y}option:${r}`,
                name: o,
                value: r,
                type: z,
                className: s(i?.className, B),
                onChange: E,
                checked: F?.includes(r),
                defaultChecked: H?.includes(r),
                label: P(e),
                readOnly: j || q(e),
                disabled: w || W(e),
                labelProps: S(e),
                multiple: R
            });
        }))
    });
}));

export { v as default };
//# sourceMappingURL=index.js.map
